import { format, subDays, startOfWeek, eachDayOfInterval, differenceInDays, parseISO } from 'date-fns';

export function getToday() {
  return format(new Date(), 'yyyy-MM-dd');
}

export function formatDate(dateStr, fmt = 'MMM d, yyyy') {
  return format(parseISO(dateStr), fmt);
}

export function getDaysAgo(days) {
  return format(subDays(new Date(), days), 'yyyy-MM-dd');
}

export function getWeekStart(date = new Date()) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

export function getDaysBetween(start, end) {
  return eachDayOfInterval({ start: parseISO(start), end: parseISO(end) }).map(
    (d) => format(d, 'yyyy-MM-dd')
  );
}

export function daysSince(dateStr) {
  return differenceInDays(new Date(), parseISO(dateStr));
}

export function getLast365Days() {
  const days = [];
  for (let i = 364; i >= 0; i--) {
    days.push(format(subDays(new Date(), i), 'yyyy-MM-dd'));
  }
  return days;
}

export function getMonthLabel(dateStr) {
  return format(parseISO(dateStr), 'MMM');
}

export function getDayOfWeek(dateStr) {
  return parseISO(dateStr).getDay();
}
